export const translationDK = {
  translation: {
    navBar: {
      title: {
        calendar: "Vælg datoer",
        accommodation: "Overnatning",
        extras: "Tilvalg",
        summary: "Oversigt",
        details: "Oplysninger",
        payment: "Betaling",
        success: "Bekræftelse",
      },
    },
    cart: {
      title: {
        calendar: "“Se ledige ophold”",
        accommodation: "Fortsæt til tilvalg",
        extras: "Gennemgå din booking",
        summary: "Indtast dine oplysninger",
        details: "fortsæt til betaling",
        payment: "Bekræft og betal",
      },
      selectArrivalDate: "Vælg en ankomstdato",
      selectDepartureDate: "Vælg venligst en afrejsedato",
      priceFrom: "Fra",
    },
    weekDays: ["søn", "man", "tirs", "ons", "tors", "fre", "lør"],
    months: [
      "januar",
      "februar",
      "marts",
      "april",
      "maj",
      "juni",
      "juli",
      "august",
      "september",
      "oktober",
      "november",
      "december",
    ],
    shortMonths: [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          description:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            { src: "see_the_top_hub.jpg", alt: "Se den øverste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Indeni den øverste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Se den nederste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Indeni den nederste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slap af i din dobbeltseng",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, du kan sidde op i sengen",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Afspil din musik med Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gå til badet i vores kimonoer",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Bliv frisket op under regnbruseren",
            },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            { src: "hair_&_makeup_area.jpg", alt: "Hår- og makeupområde" },
          ],
        },
        howManyTravellers: {
          title: "Hvor mange rejsende?",
          content:
            "Alle vores rum har behagelige senge, stemningsbelysning og den nyeste teknologi. Spørgsmålet er bare: hvordan vil du bo? <br /><br />Vores Hubs er perfekte til solorejsende og par eller venner, der nyder privatliv og en hyggelig atmosfære.<br /><br />Vælg 1 eller 2 rejsende for at se prisændringer.",
        },
        addAnotherAccomodation: {
          title: "Tilføj Hub",
          hub: {
            title: "Hub",
            description:
              "Privat Hub med dobbeltseng – perfekt til en eller to rejsende.",
          },
        },
      },
      CPH: {
        tags: ["Sauna på stedet"],
        hub: {
          title: "Hub",
          excerpt:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          description:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            { src: "see_the_top_hub.jpg", alt: "Se den øverste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Indeni den øverste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Se den nederste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Indeni den nederste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slap af i din dobbeltseng",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gå til badet i vores kimonoer",
            },
            { src: "hallway.jpg", alt: "Gang" },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
            { src: "sweat_it_out_in_our_sauna.jpg", alt: "Slap af i saunaen" },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Samme størrelse som en Hub, men opdelt i 2 enkeltmadrasser med separate dyner og en skillevæg. Ideelt til 2 personer, der ønsker hver deres plads.",
          description:
            "Samme størrelse som en Hub, men opdelt i 2 enkeltmadrasser med separate dyner og en skillevæg. Ideelt til 2 personer, der ønsker hver deres plads. Fantastisk til venner eller søskende.",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Indeni den øverste Twin Hub",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Indeni den nederste Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 enkeltmadrasser med en skillevæg",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
            { src: "sweat_it_out_in_our_sauna.jpg", alt: "Slap af i saunaen" },
          ],
        },
        room: {
          title: "Quad Room",
          excerpt:
            "Brug for mere plads? Quad Room har plads til op til 4 rejsende. Ideelt til venner eller familier. Med privat badeværelse. Også velegnet til gæster med handicap.",
          description:
            "Brug for mere plads? Quad Room har plads til op til 4 rejsende. Ideelt til venner eller familier. Med privat badeværelse. Også velegnet til gæster med handicap.",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad Room med 4 køjesenge",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad Room med en dobbeltseng og 2 køjer",
            },
            { src: "private_bathroom.jpg", alt: "Privat badeværelse" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Bliv frisket op under regnbruseren",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
            { src: "sweat_it_out_in_our_sauna.jpg", alt: "Slap af i saunaen" },
          ],
        },
        howManyTravellers: {
          title: "Hvor mange rejsende?",
          content:
            'Alle vores rum tilbyder behagelige senge, stemningsbelysning og den nyeste teknologi. Spørgsmålet er bare: hvordan vil du bo? <ul className="list-disc p-4"><li>Rejser du alene eller som par og ønsker privatliv og en hyggelig atmosfære? → Vælg en Hub.</li><li>Er I to, men foretrækker separate senge (venner eller kolleger)? → En Twin Hub er perfekt.</li><li>Leder du efter et mere rummeligt værelse med privat badeværelse? → Vælg et Quad Room.</li></ul>Uanset hvad du vælger, vil du sove godt.<br />Vælg 1 eller 2 gæster for at se prisændringer.',
        },
        addAnotherAccomodation: {
          title: "Tilføj en anden overnatning",
          hub: {
            title: "Hub",
            description:
              "Privat Hub med dobbeltseng – perfekt til en eller to rejsende.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Privat Hub med 2 enkeltsenge og en skillevæg – ideelt til venner eller søskende.",
          },
          room: {
            title: "Quad Room",
            description:
              "Privat værelse med køjesenge og privat badeværelse – perfekt til op til fire rejsende.",
          },
        },
      },
      RKV: {
        tags: ["Hot tub på taget"],
        hub: {
          title: "Hub",
          excerpt:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          description:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            { src: "see_the_top_hub.jpg", alt: "Se den øverste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Indeni den øverste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Se den nederste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Indeni den nederste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slap af i din dobbeltseng",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, du kan sidde op i sengen",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gå til badet i vores kimonoer",
            },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Slap af i vores hot tub på taget",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Samme størrelse som en Hub, men opdelt i 2 enkeltmadrasser med separate dyner og en skillevæg. Ideelt til 2 personer, der ønsker hver deres plads.",
          description:
            "Samme størrelse som en Hub, men opdelt i 2 enkeltmadrasser med separate dyner og en skillevæg. Ideelt til 2 personer, der ønsker hver deres plads. Fantastisk til venner eller søskende.",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Indeni den øverste Twin Hub",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Indeni den nederste Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 enkeltmadrasser med en skillevæg",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gå til badet i vores kimonoer",
            },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Slap af i vores hot tub på taget",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Privat Hub med dobbeltseng og en stor tv-skærm.",
          description:
            "Dette lille værelse til op til 2 rejsende har en dobbeltseng og et stort tv. Perfekt til at se film direkte fra sengen.",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slap af i din dobbeltseng",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Stort tv til dine yndlingsserier",
            },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Slap af i vores hot tub på taget",
            },
          ],
        },
        howManyTravellers: {
          title: "Hvor mange rejsende?",
          content:
            'Alle vores rum tilbyder behagelige senge, stemningsbelysning og den nyeste teknologi. Spørgsmålet er bare: hvordan vil du bo? <ul className="list-disc p-4"><li>Rejser du alene eller som par og ønsker privatliv og en hyggelig atmosfære? → Vælg en Hub.</li><li>Er I to, men foretrækker separate senge (venner eller kolleger)? → En Twin Hub er perfekt.</li><li>Leder du efter et mere traditionelt værelse med et stort tv (delt badeværelse)? → Vælg en Movie Hub.</li></ul>Uanset hvad du vælger, vil du sove godt.<br />Vælg 1 eller 2 gæster for at se prisændringer.',
        },
        addAnotherAccomodation: {
          title: "Tilføj en anden overnatning",
          hub: {
            title: "Hub",
            description:
              "Privat Hub med dobbeltseng – perfekt til en eller to rejsende.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Privat Hub med 2 enkeltsenge og en skillevæg – ideelt til venner eller søskende.",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Lille privat værelse med dobbeltseng og tv – perfekt til op til to rejsende.",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          description:
            "Din egen private Hub til op til 2 rejsende med en kingsize-seng. Perfekt til solorejsende, venner eller par, der elsker komfort.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            { src: "see_the_top_hub.jpg", alt: "Se den øverste Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Indeni den øverste Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Se den nederste Hub" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Indeni den nederste Hub",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slap af i din dobbeltseng",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, du kan sidde op i sengen",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gå til badet i vores kimonoer",
            },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Bliv frisket op under regnbruseren",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Samme størrelse som en Hub, men opdelt i 2 enkeltmadrasser med separate dyner og en skillevæg. Ideelt til 2 personer, der ønsker hver deres plads.",
          description:
            "Samme størrelse som en Hub, men opdelt i 2 enkeltmadrasser med separate dyner og en skillevæg. Ideelt til 2 personer, der ønsker hver deres plads. Fantastisk til venner eller søskende.",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hubben er formet som et L",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Indeni den nederste Twin Hub",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Slap af i din dobbeltseng",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gå til badet i vores kimonoer",
            },
            { src: "women_s_bathroom.jpg", alt: "Damebadeværelse" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Bliv frisket op under regnbruseren",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrebadeværelse" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Gratis Rituals-produkter",
            },
          ],
        },
        howManyTravellers: {
          title: "Hvor mange rejsende?",
          content:
            'Alle vores rum tilbyder behagelige senge, stemningsbelysning og den nyeste teknologi. Spørgsmålet er bare: hvordan vil du bo? <ul className="list-disc p-4"><li>Rejser du alene eller som par og ønsker privatliv og en hyggelig atmosfære? → Vælg en Hub.</li><li>Er I to, men foretrækker separate senge (venner eller kolleger)? → En Twin Hub er perfekt.</li></ul>Uanset hvad du vælger, vil du sove godt.<br />Vælg 1 eller 2 gæster for at se prisændringer.',
        },
        addAnotherAccomodation: {
          title: "Tilføj en anden overnatning",
          hub: {
            title: "Hub",
            description:
              "Privat Hub med dobbeltseng – perfekt til en eller to rejsende.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Privat Hub med 2 enkeltsenge og en skillevæg – ideelt til venner eller søskende.",
          },
        },
      },
      tags: {
        hub: [
          "Privat Hub til 1-2 personer",
          "1 dobbeltseng",
          "Delte badeværelser",
          "Rituals-toiletartikler",
          "Håndklæder",
          "Kimonoer",
        ],
        twinHub: [
          "Privat Hub til 2 personer",
          "2 enkeltmadrasser med skillevæg",
          "Delte badeværelser",
          "Rituals-toiletartikler",
          "Håndklæder",
          "Kimonoer",
        ],
        room: [
          "20m² værelse til 1-4 personer",
          "4 køjesenge eller 2 køjer og en dobbeltseng",
          "Privat badeværelse",
          "Rituals-toiletartikler",
          "Håndklæder",
          "Kimonoer",
          "Adgang for kørestolsbrugere",
        ],
        movieHub: [
          "Privat Hub til 1-2 personer",
          "1 dobbeltseng",
          "Delte badeværelser",
          "Rituals-toiletartikler",
          "Håndklæder",
          "Kimonoer",
          "Tv",
        ],
      },
      faq: {
        hub: [
          {
            q: "Øverste eller nederste Hub? Kan jeg vælge?",
            a: "Jeps. En Hub er din egen private sovepod, formet som et L og lavet til 2 personer. Hubs kommer stablet i par: en øverst og en nederst. Ved check-in beslutter du, om du hellere vil klatre op eller dykke ned.",
          },
          {
            q: "Fortæl mig mere om denne Hub.",
            a: "Din 6m² Hub er udstyret med smart opbevaringsplads, stikkontakter og WiFi. Sengene er gjort klar til dig. Du kan indstille Hub-belysningen til at passe til dit humør med CityHub-appen. Inkluderer Bluetooth-musikstreaming.",
          },
          {
            q: "Er der klimaanlæg i Hubben?",
            a: "Ja, din Hub er forbundet til et centralt klimakontrolsystem indstillet på det mest komfortable niveau for den gennemsnitlige rejsende.",
          },
          {
            q: "Hvordan er badeværelserne?",
            a: "Ganske luksuriøse. De er delte, men adskilte for mænd og kvinder, de kommer med regnbrusere og gratis Rituals-produkter. Vi holder dem super rene, hele dagen, hver dag.",
          },
          {
            q: "Har I håndklæder? Hvad ellers behøver jeg ikke at tage med?",
            a: "Vi har det hele her til dig. Håndklæder, Rituals-sæbe, shampoo, hårtørrer og ja, vi har et strygejern. Vidste du, at vi også har specielle CityHub-kimonoer? Ret praktiske at bruge, når man skal gå hen til bruseren. Tag dog dine egne klipklappere med.",
          },
          {
            q: "Kan jeg tage børn med?",
            a: "Vi elsker børn, virkelig. Desværre er vores delte faciliteter ikke egnede til babyer eller meget små børn under 6 år. Bemærk, at en Hub maksimalt har plads til 2 personer. Det inkluderer børn.",
          },
        ],
        twinHub: [
          {
            q: "Øverste eller nederste Hub? Kan jeg vælge?",
            a: "Jeps. En Hub er din egen private sovepod, formet som et L og lavet til 2 personer. Hubs kommer stablet i par: en øverst og en nederst. Ved check-in beslutter du, om du hellere vil klatre op eller dykke ned.",
          },
          {
            q: "Fortæl mig mere om denne Hub.",
            a: "Din 6m² Hub er udstyret med smart opbevaringsplads, stikkontakter og WiFi. Sengene er gjort klar til dig. Du kan indstille Hub-belysningen til at passe til dit humør med CityHub-appen. Inkluderer Bluetooth-musikstreaming.",
          },
          {
            q: "Er der klimaanlæg i Hubben?",
            a: "Ja, din Hub er forbundet til et centralt klimakontrolsystem indstillet på det mest komfortable niveau for den gennemsnitlige rejsende.",
          },
          {
            q: "Hvordan er badeværelserne?",
            a: "Ganske luksuriøse. De er delte, men adskilte for mænd og kvinder, de kommer med regnbrusere og gratis Rituals-produkter. Vi holder dem super rene, hele dagen, hver dag.",
          },
          {
            q: "Har I håndklæder? Hvad ellers behøver jeg ikke at tage med?",
            a: "Vi har det hele her til dig. Håndklæder, Rituals-sæbe, shampoo, hårtørrer og ja, vi har et strygejern. Vidste du, at vi også har specielle CityHub-kimonoer? Ret praktiske at bruge, når man skal gå hen til bruseren. Tag dog dine egne klipklappere med.",
          },
          {
            q: "Kan jeg tage børn med?",
            a: "Vi elsker børn, virkelig. Desværre er vores delte faciliteter ikke egnede til babyer eller meget små børn under 6 år. Bemærk, at en Hub maksimalt har plads til 2 personer. Det inkluderer børn.",
          },
        ],
        room: [
          {
            q: "Fortæl mig mere om dette Quad room.",
            a: "Dit Quad Room har eget badeværelse og er udstyret med stikkontakter og WiFi. Sengene er redt op til dig. Du kan indstille lyset i værelset til at passe til dit humør med CityHub-appen. Bluetooth-musikstreaming er inkluderet.",
          },
          {
            q: "Er der klimaanlæg i Quad room?",
            a: "Ja, dit Quad room er forbundet til et centralt klimakontrolsystem indstillet på det mest komfortable niveau for den gennemsnitlige rejsende.",
          },
          {
            q: "Har I håndklæder? Hvad ellers behøver jeg ikke at tage med?",
            a: "Vi har det hele her til dig. Håndklæder, Rituals-sæbe, shampoo, hårtørrer og ja, vi har et strygejern. Vidste du, at vi også har specielle CityHub-kimonoer? Ret praktiske at bruge, når man skal gå hen til bruseren. Tag dog dine egne klipklappere med.",
          },
          {
            q: "Kan jeg tage børn med?",
            a: "Vi elsker børn, virkelig. Desværre er vores delte faciliteter ikke egnede til babyer eller meget små børn under 6 år. Bemærk, at et Quad Room maksimalt har plads til 4 personer. Det inkluderer børn.",
          },
        ],
        movieHub: [
          {
            q: "Fortæl mig mere om denne Movie Hub.",
            a: "Din Movie Hub er udstyret med smart opbevaringsplads, stikkontakter, WiFi og en stor tv-skærm. Sengene er redt op til dig. Du kan indstille lyset til at passe til dit humør med CityHub-appen. Komplet med Bluetooth-musikstreaming.",
          },
          {
            q: "Er der klimaanlæg i Movie Hubben?",
            a: "Ja, din Movie Hub er forbundet til et centralt klimakontrolsystem indstillet på det mest komfortable niveau for den gennemsnitlige rejsende.",
          },
          {
            q: "Hvordan er badeværelserne?",
            a: "Ganske luksuriøse. De er delte, men adskilte for mænd og kvinder, og de kommer med regnbrusere og gratis toiletartikler. Vi holder dem super rene, hele dagen, hver dag.",
          },
          {
            q: "Har I håndklæder? Hvad ellers behøver jeg ikke at tage med?",
            a: "Vi har det hele her til dig. Håndklæder, Rituals-sæbe, shampoo, hårtørrer og ja, vi har et strygejern. Vidste du, at vi også har specielle CityHub-kimonoer? Ret praktiske at bruge, når man skal gå hen til bruseren. Tag dog dine egne klipklappere med.",
          },
          {
            q: "Kan jeg tage børn med?",
            a: "Vi elsker børn, virkelig. Desværre er vores delte faciliteter ikke egnede til babyer eller meget små børn under 6 år. Bemærk, at en Hub maksimalt har plads til 2 personer. Det inkluderer børn.",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Vælg by",
        button: { label: "Vælg by" },
      },
      selectCulture: {
        title: "sprog og valuta",
        button: { label: "gem ændringer" },
      },
      uspBar: {
        title: "Laveste pris garanteret",
        content:
          "Vi garanterer, at hvis du booker via denne hjemmeside, får du altid den bedst mulige pris.",
      },
    },
    component: {
      uspBar: {
        title: "Laveste pris garanteret",
      },
    },
    scenes: {
      traveller_one: "rejsende",
      traveller_other: "rejsende",
      night_one: "nat",
      night_other: "nætter",
      selectHotel: {
        chooseCity: "book nu, vælg din by",
      },
      accommodation: {
        pricePerNight: "pris pr. nat",
        pricePerNightInclVat: "pris pr. nat (inkl. moms)",
        remove: "fjern",
        directBookingDiscount: "rabat ved direkte booking",
        notAvailable: "ikke ledig",
        unavailable: "ikke ledig",
        noMoreRoomsAvailable: "Book nu · sidste Hub",
        addAnotherRoom: "tilføj værelse",
        addAnotherHub: "tilføj Hub",
        howManyTravellers: "hvor mange rejsende?",
        questions: "ofte stillede spørgsmål",
        moreTags_one: "ekstra funktion",
        moreTags_other: "ekstra funktioner",
        more_info: "mere info",
        not_available: "Ikke tilgængelig på denne dato",
        show_more: "Mere information",
        show_less: "Mindre information",
        selected: "valgt",
      },
      calendar: {
        startNotice: "{{hotelName}} åbner dørene den {{startDate}}",
      },
      extras: {
        perPersonPerNight: "pr. person, pr. nat",
        add: "tilføj",
        remove: "fjern",
        moreInfo: "mere info",
      },
      summary: {
        perNight: "/ nat",
        checkIn: "CHECK-IN",
        checkOut: "CHECK-OUT",
        rate: "pris:",
        discount: "rabat:",
        from: "fra",
        before: "før",
        total: "total",
        incCityTax: "Turistskat",
        incVat: "inkluderet moms",
        incVatRooms: "Inkl. moms værelser",
        incVatProducts: "Inkl. moms produkter",
        directBookingDiscount: "rabat ved direkte booking",
        voucher: "voucher",
        addVoucher: "tilføj voucher",
        voucherInvalid: "koden er ikke korrekt",
        voucherNotApplicable: "voucheren gælder ikke for den valgte pris",
      },
      details: {
        firstName: "fornavn",
        firstNameRequired: "fornavn mangler",
        lastName: "efternavn",
        lastNameRequired: "efternavn mangler",
        email: "e-mail",
        emailRequired: "e-mail mangler",
        emailInvalid: "e-mail skal indeholde @ og mindst ét punktum",
        phoneMin: "telefonnummer skal være på mindst 9 cifre",
        phoneInvalid: "telefonnummer skal bestå af tal",
        countryRequired: "land er et obligatorisk felt",
        phone: "telefonnummer",
        country: "land",
        selectCountry: "vælg dit land",
        specialRequests: "særlige ønsker",
        terms:
          "Jeg accepterer hotellets <firstLink>vilkår og betingelser</firstLink> og <secondLink>privatlivspolitik.</secondLink>",
        marketingEmails:
          "Jeg vil gerne modtage markedsføringsopdateringer en gang imellem.",
        createReservation: "opret reservation",
        finishPaymentAtKiosk:
          "afslut betalingen i vores selvbetjeningsautomat.",
        creatingReservation: "opretter din reservation...",
        reservationCreated: "reservation oprettet!",
        somethingWentWrong: "noget gik galt, prøv venligst igen.",
      },
      payment: {
        paymentMethods: "betalingsmetoder",
        paymentMethodsDescription:
          "Kun ét skridt tilbage – gennemfør din betaling sikkert herunder. Vi bruger krypterede betalingsmetoder for at beskytte dine oplysninger. Når betalingen er bekræftet, modtager du en bekræftelsesmail.",
        authorizeCreditCard: "godkend kreditkort",
        cardChargeInfo: "dit kort vil blive debiteret 48 timer før ankomst",
        securedWithMews: "sikret med Mews Payments via PCI Proxy",
        payWithCreditCard: "betal med kreditkort",
        payDirectly: "betal med det samme",
        onlyVisaAndMastercardSupported: "kun Visa og MasterCard accepteres",
        nameOnCreditCard: "navn på kortet",
        cardNumber: "kortnummer",
        expirationDate: "udløbsdato",
        expirationDateRequired: "udløbsdato mangler",
        yearCanNotBeInThePast: "året kan ikke være i fortiden",
        yearCanNotBeMoreThan5YearsInTheFuture:
          "året må ikke være mere end 5 år ude i fremtiden",
        monthCanNotBeInThePast: "måneden kan ikke være i fortiden",
        monthCanNotBeBiggerThan12: "måneden kan ikke være større end 12",
        shouldBeAMonthAndAYear: "skal være måned og år MM/ÅÅÅÅ",
        validateCard: "valider kort",
        createReservation: "opret reservation",
        nameIsRequired: "navn mangler",
        cardNumberIsRequired: "kortnummer mangler",
        invalidCardNumber: "ugyldigt kortnummer",
        cvcIsRequired: "CVC mangler",
        invalidCvc: "ugyldig CVC",
        somethingWentWrong: "noget gik galt. Prøv venligst igen senere.",
        somethingWentWrong4501:
          "noget gik galt (4501). Prøv venligst igen senere.",
        creatingReservation: "opretter din reservation...",
        reservationCreated: "reservation oprettet!",
        finishPayment: "færdiggør din betaling...",
        creditcardNotAuthorizable: "kreditkortet kunne ikke godkendes",
      },
      success: {
        bookingConfirmed: "booking bekræftet!",
        bookingConfirmedDescription:
          "dit ophold hos {{hotelName}} er klar. <br/>Check-in fra kl. 15:00. Vi ses snart 👋",
        startChatting: "begynd at chatte",
        viewBookingDetails: "se bookingoplysninger",
        bookingDetails: "bookingoplysninger",
        whatsNext: "hvad nu?",
        connectWithHost:
          "kontakt din CityHost, din personlige kontakt døgnet rundt for gode råd, vejledning og lokale hemmeligheder.",
        online: "ONLINE",
      },
      pageNotFound: {
        message: "ups! <br />Vi kan ikke finde den side, du leder efter.",
        linkText: "vælg hotel for at komme i gang",
      },
      redirectHotel: {
        message: "indlæser hotelkonfiguration...",
      },
      redirectPayment: {
        error4602: "[fejl" + ":4602] ingen reservation fundet",
        noPaymentsFound: "ingen betalinger fundet",
        paymentSuccessful: "betaling lykkedes",
        paymentFailed: "betaling mislykkedes",
        returningToSite: "vender tilbage til hjemmesiden...",
        authorizationPending: "godkendelse afventer",
        authorizationPendingMessage:
          "din reservation er oprettet, men godkendelsen afventer stadig.<br /><br />Klik her for at godkende dit kort.",
      },
    },
    form: {
      language: {
        label: "sprog",
        placeholder: "vælg sprog",
        options: {
          "en-US": "engelsk",
          "nl-NL": "hollandsk",
          "is-IS": "islandsk",
          "de-DE": "tysk",
          "fr-FR": "fransk",
          "it-IT": "italiensk",
          "da-DK": "dansk",
        },
        validation: { required: "vælg venligst et sprog" },
      },
      currency: {
        label: "valuta",
        placeholder: "vælg valuta",
        options: {
          EUR: "euro (€)",
          USD: "amerikanske dollar ($)",
          GBP: "britiske pund (£)",
          CAD: "canadiske dollar (C$)",
          DKK: "danske kroner (DKK)",
          ISK: "islandske kroner (ISK)",
        },
        validation: { required: "vælg venligst en valuta" },
      },
    },
  },
};
